module.exports = __webpack_public_path__ + "static/assets/e19b41b321fe53ee7158064aa419959d.png";